import {get, post} from './api';

// 创建订单
const createOrder = post('order/create')


// 查询订单状态
const orderStatus = get('order/get')

//查询优惠码
const inquiryCode = get('channel/get-public-info-by-code')




export {
    createOrder,
    orderStatus,
    inquiryCode
}